/* MingSilk R11 — request-flow companion.
   Two jobs the four-step wizard did not do:

   1. Carry the fabric across from the product page (?fabric=<handle>), so a
      buyer who clicked "Request free swatches" on a specific silk sees that
      silk already in the brief.
   2. Progressive capture: when the buyer leaves step 2 we post what we know
      with contact[Request stage]=partial. Abandoning at the address step then
      still leaves a followable lead instead of nothing.

   Deliberately decoupled from mingsilk-request-flow-v11.js: it observes the
   panels rather than hooking the wizard's internals, so the wizard can change
   without breaking this. */
(function () {
  'use strict';

  var root = document.querySelector('[data-mingsilk-request-v10]');
  if (!root) return;

  var form = root.querySelector('form');
  var params = new URLSearchParams(window.location.search);
  var routePrefix = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------------------------------------------------------- fabric carry */

  function labelFromHandle(handle) {
    return handle.replace(/-/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); });
  }

  function preselectFamily(title) {
    var haystack = title.toLowerCase();
    var boxes = root.querySelectorAll('[data-v10-multi="families"]');
    for (var i = 0; i < boxes.length; i++) {
      var value = String(boxes[i].value || '').toLowerCase();
      // "Crepe de Chine" -> match on the distinctive first word
      var key = value.split(/[\s/]/)[0];
      if (key.length > 3 && haystack.indexOf(key) !== -1) {
        if (!boxes[i].checked) {
          boxes[i].checked = true;
          boxes[i].dispatchEvent(new Event('change', { bubbles: true }));
        }
        return value;
      }
    }
    return null;
  }

  function showContext(title, imageUrl, url) {
    var slot = root.querySelector('[data-r11-fabric-context]');
    if (!slot) return;
    var media = imageUrl
      ? '<img src="' + imageUrl + '" alt="" width="48" height="60" loading="lazy">'
      : '';
    slot.innerHTML =
      media +
      '<div><small>Starting from</small><strong>' + title + '</strong></div>' +
      (url ? '<a href="' + url + '">View fabric</a>' : '');
    slot.hidden = false;
  }

  var fabricHandle = params.get('fabric');
  if (fabricHandle && /^[a-z0-9-]+$/i.test(fabricHandle)) {
    var field = root.querySelector('[data-r11-fabric-field]');
    var fallback = labelFromHandle(fabricHandle);
    if (field) field.value = fallback;
    showContext(fallback, null, null);

    fetch(routePrefix.replace(/\/$/, '') + '/products/' + fabricHandle + '.js', {
      headers: { Accept: 'application/json' }
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.title) return;
        var family = preselectFamily(p.title);
        if (field) field.value = p.title + (family ? ' (' + family + ')' : '');
        showContext(p.title, p.featured_image || (p.images && p.images[0]) || null, p.url);
      })
      .catch(function () { /* the handle-derived fallback is already shown */ });
  }

  /* -------------------------------------------------- progressive capture */

  var partialSent = false;

  function collect() {
    var data = new FormData();
    data.append('form_type', 'contact');
    data.append('utf8', '\u2713');

    var email = root.querySelector('[data-r11-email]');
    if (!email || !email.value || !email.validity.valid) return null;
    data.append('contact[email]', email.value);
    data.append('contact[Request stage]', 'partial');

    // Everything already answered in steps 1-2.
    var carry = [
      'contact[Request route]', 'contact[Intended use]', 'contact[Estimated quantity]',
      'contact[Target timing]', 'contact[Silk families]', 'contact[Characteristics]',
      'contact[Colour direction]', 'contact[Weight or momme]', 'contact[Fabric from page]'
    ];
    var summary = [];
    carry.forEach(function (name) {
      var el = form.querySelector('[name="' + name + '"]:checked') || form.querySelector('[name="' + name + '"]');
      if (el && el.value) {
        data.append(name, el.value);
        summary.push(name.replace(/^contact\[|\]$/g, '') + ': ' + el.value);
      }
    });

    data.append(
      'contact[body]',
      'PARTIAL REQUEST - the buyer reached the delivery step but has not submitted yet.\n\n' +
        summary.join('\n') +
        '\n\nPage: ' + window.location.href
    );
    return data;
  }

  function sendPartial() {
    if (partialSent) return;
    var data = collect();
    if (!data) return;
    partialSent = true;
    fetch(routePrefix.replace(/\/$/, '') + '/contact', {
      method: 'POST',
      body: data,
      credentials: 'same-origin'
    }).catch(function () { partialSent = false; });
  }

  // A finished submission carries stage=complete, so stop the partial firing.
  if (form) form.addEventListener('submit', function () { partialSent = true; });

  var stepThree = root.querySelector('[data-v10-step="3"]');
  if (stepThree) {
    new MutationObserver(function () {
      if (!stepThree.hasAttribute('hidden')) sendPartial();
    }).observe(stepThree, { attributes: true, attributeFilter: ['hidden'] });
  }
})();
